module.exports = __webpack_public_path__ + "img/ceo_info_area_chart.efc6dac5.png";